module.exports = __webpack_public_path__ + "static/img/1-1.a0d2d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/1-1.png
// module id = y/Ay
// module chunks = 0